import { useEffect } from "react";

export default function SignupButtonBehaviour() {

  useEffect(() => {

// ==========================
// INPUTS
// ==========================
const form = document.querySelector("form");

const firstName = document.getElementById("firstNameInput");
const lastName = document.getElementById("lastNameInput");
const email = document.getElementById("emailInput");
const password = document.getElementById("passwordInput");
const confirmPassword = document.getElementById("confirmPasswordInput");
const checkbox = document.getElementById("flexCheckDefault");
const phoneInput = document.getElementById("phoneInput");
const iti =
  phoneInput && window.intlTelInput && window.intlTelInput.getInstance
    ? window.intlTelInput.getInstance(phoneInput)
    : null;

// ==========================
// REGEX
// ==========================
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// ==========================
// HELPER
// ==========================
function setError(input) {
    const wrap = input.closest(".custom-floating");
    if (!wrap) return;
    wrap.classList.add("error");
    if (window.App && window.App.ensureFloatingErrorText) {
      window.App.ensureFloatingErrorText(wrap);
    }
}

function removeError(input) {
    const wrap = input.closest(".custom-floating");
    if (!wrap) return;
    wrap.classList.remove("error");
    input.removeAttribute("aria-invalid");
}

// ==========================
// VALIDATION
// ==========================
form.addEventListener("submit", function (e) {
 console.log("FORM SUBMIT TRIGGERED");

    let isValid = true;

    // First Name
    if (!firstName.value.trim()) {
        setError(firstName);
        isValid = false;
    } else removeError(firstName);

    // Last Name
    if (!lastName.value.trim()) {
        setError(lastName);
        isValid = false;
    } else removeError(lastName);

    // Email
    if (!emailRegex.test(email.value.trim())) {
        setError(email);
        isValid = false;
    } else removeError(email);

    // Phone (intl-tel-input validation)
    if (
      !phoneInput ||
      !phoneInput.value.trim() ||
      (iti && !iti.isValidNumber())
    ) {
      if (phoneInput) setError(phoneInput);
      isValid = false;
    } else removeError(phoneInput);

    // Password
    if (password.value.length < 6) {
        setError(password);
        isValid = false;
    } else removeError(password);

    // Confirm Password
    if (confirmPassword.value !== password.value || !confirmPassword.value) {
        setError(confirmPassword);
        isValid = false;
    } else removeError(confirmPassword);

    // Checkbox
    if (!checkbox.checked) {
        checkbox.classList.add("is-invalid");
        isValid = false;
    } else {
        checkbox.classList.remove("is-invalid");
    }

    if (!isValid) {
        e.preventDefault();
    }
});

// ==========================
// LIVE FEEDBACK (smooth UX)
// ==========================
document.querySelectorAll("input").forEach(input => {
    input.addEventListener("input", function () {
        if (this.value.trim()) {
            removeError(this);
        }
    });
});


  }, []);

  return null;
}
